import React, { PureComponent } from 'react';
import { YMaps, Map, ZoomControl } from 'react-yandex-maps';

import './RouteMap.css';

class RouteMap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      center: [55.753215, 37.622504],
      ymaps: false,
      map: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.map !== prevState.map) {
      this.renderRoute(this.state.map);
    }
  }

  renderRoute = ref => {
    ref.geoObjects.removeAll();

    const { markers } = this.props;

    if (markers.length === 1) {
      this.state.ymaps
        .geocode(markers[0], {
          results: 1,
        })
        .then(res => {
          const bounds = res.geoObjects.get(0).properties.get('boundedBy');

          ref.setBounds(bounds, {
            checkZoomRange: true,
          });
        });
    } else {
      const multiRoute = new this.state.ymaps.multiRouter.MultiRoute(
        {
          referencePoints: markers,
          params: {
            results: 1,
          },
        },
        {
          boundsAutoApply: markers.length > 1,
        }
      );

      ref.geoObjects.add(multiRoute);
    }
  };

  initYmaps = ymaps => {
    this.setState(() => ({
      ymaps: ymaps,
    }));
  };

  initMap = ref => {
    if (!this.state.map) {
      this.setState(() => ({
        map: ref,
      }));
    }
  };

  render() {
    return (
      <div className="routeMap">
        <YMaps
          query={{
            apikey: 'b6a66b8f-dc2c-4946-a916-0fb0ca680e5a',
          }}
          onApiAvaliable={ymaps => this.initYmaps(ymaps)}
        >
          <Map
            state={{
              center: this.state.center,
              zoom: 14,
              controls: [],
              behaviors: ['drag'],
            }}
            width={'100%'}
            height={'910px'}
            instanceRef={this.initMap}
          >
            <ZoomControl options={{ float: 'right' }} />
          </Map>
        </YMaps>
      </div>
    );
  }
}

export default RouteMap;
